import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import remarkGfm from 'remark-gfm';
import Terminal from './Terminal';
import { Chapter as ChapterType } from '../data/chapters';

interface ChapterProps {
  chapter: ChapterType;
  onPrev: () => void;
  onNext: () => void;
  isFirst: boolean;
  isLast: boolean;
}

export default function Chapter({ chapter, onPrev, onNext, isFirst, isLast }: ChapterProps) {
  return (
    <article className="chapter">
      <header className="chapter-header">
        <div className="chapter-eyebrow">
          {chapter.number === 0 ? 'prologue' : `chapter ${chapter.number}`}
        </div>
        <h1 className="chapter-title">{chapter.title}</h1>
        <p className="chapter-subtitle">{chapter.subtitle}</p>
      </header>

      <div className="chapter-content">
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            code({ node, inline, className, children, ...props }: any) {
              const match = /language-(\w+)/.exec(className || '');
              const lang = match ? match[1] : 'text';
              
              if (!inline && match) {
                return (
                  <SyntaxHighlighter
                    style={oneDark}
                    language={lang}
                    PreTag="div"
                    customStyle={{
                      background: '#0d0d0d',
                      padding: '16px',
                      margin: 0,
                      borderRadius: '6px',
                      fontSize: '12px',
                    }}
                    {...props}
                  >
                    {String(children).replace(/\n$/, '')}
                  </SyntaxHighlighter>
                );
              }
              
              return (
                <code className={className} {...props}>
                  {children}
                </code>
              );
            },
          }}
        >
          {chapter.content}
        </ReactMarkdown>

        {chapter.terminalCommands && chapter.terminalCommands.length > 0 && (
          <Terminal commands={chapter.terminalCommands} title="terminal" />
        )}
      </div>

      <nav className="chapter-nav">
        <button className="chapter-nav-btn" onClick={onPrev} disabled={isFirst}>
          ← previous
        </button>
        <button className="chapter-nav-btn" onClick={onNext} disabled={isLast}>
          next →
        </button>
      </nav>
    </article>
  );
}
